import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IProtoGroup } from './IProtoGroup';

/**
 * Назва групи форми мовою інтерфейсу, як на сторінці запису (FieldGroup): рядок пакета модуля за ідентифікатором групи, інакше переклад
 * стандартної групи за англійською назвою, інакше назва групи; без назви — «Група без назви» (прототип v4 'Untitled group').
 */
export function useGroupName(rtKey: string): (group: Pick<IProtoGroup, 'id' | 'title'>) => string {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  return useCallback((group) => {
    const standard = group.title.en ? t(`form.groups.${group.title.en}`, { defaultValue: '' }) : '';
    return strings.formGroup(rtKey, group.id, standard || group.title) || t('modSettings.form.untitled');
  }, [t, strings, rtKey]);
}
